import { Button } from '../../ui/Button';
import { connectorsPath } from '../../../../lib/connectors-route';
import { useTranslation } from '../../../../lib/i18n';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { CHAT_HOME_BI } from '../message-utils';

/**
 * The [Reconnect] under the "can't join your meetings" line (`metadata.meetingReconnect`, VMR #35381). It opens the
 * Meetings section of Connectors, where the owner connects again: the connect and the calendar step live there.
 */
export function MeetingReconnectButton() {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        href={connectorsPath({ tab: 'channels', target: 'meetings' })}
        onClick={() => logPageClickBi({ ...CHAT_HOME_BI, button_name: 'meeting-reconnect' })}
      >
        {t('connectors.meetings.reconnect')}
      </Button>
    </div>
  );
}
